import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AutoForecastSettingApi, UpdateAutoForecastSettingBody } from 'api';

export const findOneAutoForecastSettingWithEntity = createAsyncThunk(
  'autoForecastSetting/findOneAutoForecastSettingWithEntity',
  async (any, { rejectWithValue }) => {
    try {
      const response = await AutoForecastSettingApi.findWithEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAutoForecastSetting = createAsyncThunk(
  'autoForecastSetting/updateAutoForecastSetting',
  async (
    params: { id: string; body: UpdateAutoForecastSettingBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await AutoForecastSettingApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InitialState {
  data: any | undefined;
}

const initialState: InitialState = {
  data: undefined,
};

const autoForecastSettingSlice = createSlice({
  name: 'autoForecastSetting',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      findOneAutoForecastSettingWithEntity.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        state.data = data;
      }
    );
    builder.addCase(updateAutoForecastSetting.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = {
        ...state.data,
        ...data,
      };
    });
  },
});

const { reducer: AutoForecastSettingReducer } = autoForecastSettingSlice;

export default AutoForecastSettingReducer;
